import { Component } from "react";
import { Button } from "@/components/ui/button";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="error-boundary">
        <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl p-6 space-y-4 text-center shadow-sm">
          <h1 className="font-heading text-xl font-bold">Algo ha fallado al cargar esta pantalla</h1>
          <p className="text-sm text-slate-500">
            Prueba a recargar. Si sigue fallando, avisa al administrador con este detalle:
          </p>
          <p className="text-xs text-slate-400 bg-slate-50 border border-slate-200 rounded-lg p-3 break-words" data-testid="error-boundary-detail">
            {String(this.state.error?.message || this.state.error)}
          </p>
          <Button data-testid="error-boundary-reload" onClick={() => window.location.reload()}
            className="bg-[#D9381E] hover:bg-[#B91C1C] text-white">
            Recargar
          </Button>
        </div>
      </div>
    );
  }
}
